import _regeneratorRuntime from "/Volumes/VANE/marciano/studio4x4-suzuki-ecommerce/node_modules/@babel/runtime-corejs2/regenerator";
import "core-js/modules/es6.regexp.replace";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Volumes/VANE/marciano/studio4x4-suzuki-ecommerce/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";

/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/
import 'quasar/dist/quasar.ie.polyfills.js';
import '@quasar/extras/eva-icons/eva-icons.css'; // We load Quasar stylesheet file

import 'quasar/dist/quasar.sass'; // We add Quasar addons, if they were requested

import 'quasar/src/css/flex-addon.sass';
import 'src/css/app.scss';
import '@quasar/quasar-ui-qmarkdown/src/index.sass';
import Vue from 'vue';
import createApp from "./app.js";
import 'app/src-pwa/register-service-worker.js';
import qboot_Bootaxios from 'boot/axios';
import qboot_Bootauth from 'boot/auth';
import qboot_Bootcookies from 'boot/cookies';
import qboot_Bootnotify from 'boot/notify';
import qboot_Bootrouter from 'boot/router';
import qboot_Bootfilters from 'boot/filters';
import qboot_Bootmarkdown from 'boot/markdown';
import qboot_Bootaos from 'boot/aos';
import qboot_Quasarquasarappextensionqmarkdownsrcbootregisterjs from '@quasar/quasar-app-extension-qmarkdown/src/boot/register.js';
import { addPreFetchHooks } from "./client-prefetch.js"; // Needed only for iOS PWAs

if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream && window.navigator.standalone) {
  import(
  /* webpackChunkName: "fastclick"  */
  '@quasar/fastclick');
}

function start() {
  return _start.apply(this, arguments);
}

function _start() {
  _start = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var _ref, app, store, router, routeUnchanged, redirect, urlPath, bootFiles, i;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return createApp();

          case 2:
            _ref = _context.sent;
            app = _ref.app;
            store = _ref.store;
            router = _ref.router;
            routeUnchanged = true;

            redirect = function redirect(url) {
              routeUnchanged = false;
              window.location.href = url;
            };

            urlPath = window.location.href.replace(window.location.origin, '');
            bootFiles = [qboot_Bootaxios, qboot_Bootauth, qboot_Bootcookies, qboot_Bootnotify, qboot_Bootrouter, qboot_Bootfilters, qboot_Bootmarkdown, qboot_Bootaos, qboot_Quasarquasarappextensionqmarkdownsrcbootregisterjs];
            i = 0;

          case 11:
            if (!(routeUnchanged === true && i < bootFiles.length)) {
              _context.next = 29;
              break;
            }

            if (!(typeof bootFiles[i] !== 'function')) {
              _context.next = 14;
              break;
            }

            return _context.abrupt("continue", 26);

          case 14:
            _context.prev = 14;
            _context.next = 17;
            return bootFiles[i]({
              app: app,
              router: router,
              store: store,
              Vue: Vue,
              ssrContext: null,
              redirect: redirect,
              urlPath: urlPath
            });

          case 17:
            _context.next = 26;
            break;

          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](14);

            if (!(_context.t0 && _context.t0.url)) {
              _context.next = 24;
              break;
            }

            window.location.href = _context.t0.url;
            return _context.abrupt("return");

          case 24:
            console.error('[Quasar] boot error:', _context.t0);
            return _context.abrupt("return");

          case 26:
            i++;
            _context.next = 11;
            break;

          case 29:
            if (!(routeUnchanged === false)) {
              _context.next = 31;
              break;
            }

            return _context.abrupt("return");

          case 31:
            addPreFetchHooks(router, store);
            new Vue(app);

          case 33:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[14, 19]]);
  }));
  return _start.apply(this, arguments);
}

start();